import {useMemo} from 'react';
import {RoleId} from '../../../../../shared/constants';
import {RootState} from '../../../../../redux/store';
import {useSelector} from 'react-redux';

interface UseMediaViewerReturn {
  loginUsername: string;
  annotationLayerId?: string;
  showMarkControl: boolean;
  showMediaRedaction: boolean;
  showMediaReviewerRemarks: boolean;
  showMediaReviewerRemarksPanel: boolean;
}

const useMediaViewer = (): UseMediaViewerReturn => {
  const loginUserData = useSelector(
    (state: RootState) => state.authenticatedUser.user
  );

  const docViewConfiguration = useSelector(
    (state: RootState) => state.docView.docViewConfiguration
  );

  const showMediaReviewerRemarksPanel = useSelector(
    (state: RootState) => state.docView.showMediaReviewerRemarksPanel
  );

  const annotationLayerId = useMemo(
    () => docViewConfiguration.annotationLayerId,
    [docViewConfiguration.annotationLayerId]
  );

  const loginUsername = useMemo(
    () => loginUserData.userName,
    [loginUserData.userName]
  );

  const showMarkControl = useMemo(
    () =>
      Boolean(
        loginUserData.roleId.toString() != RoleId.ProjectAdministrator &&
        Boolean(Number(annotationLayerId))
      ),
    [annotationLayerId, loginUserData.roleId]
  );

  const showMediaRedaction = useMemo(
    () => showMarkControl && !!docViewConfiguration.audioRedactions,
    [docViewConfiguration.audioRedactions, showMarkControl]
  );

  const showMediaReviewerRemarks = useMemo(
    () => showMarkControl && !!docViewConfiguration.reviewerRemarks,
    [docViewConfiguration.reviewerRemarks, showMarkControl]
  );

  return {
    loginUsername,
    annotationLayerId,
    showMarkControl,
    showMediaRedaction,
    showMediaReviewerRemarks,
    showMediaReviewerRemarksPanel,
  };
};

export {useMediaViewer};
